import { render } from "./VaIconColor.vue?vue&type=template&id=3c91687b"
import script from "./VaIconColor.vue?vue&type=script&lang=js"
export * from "./VaIconColor.vue?vue&type=script&lang=js"

import "./VaIconColor.vue?vue&type=style&index=0&id=3c91687b&lang=scss"
script.render = render

export default script